import getFirstLayerIdFromTiers from 'Map/tier/styleUpdate/getFirstLayerIdsFromTiers';
import getLastLayerIdFromTiers from 'Map/tier/styleUpdate/getLastLayerIdsFromTiers';
import findNonTierLayersIds from 'Map/tier/styleUpdate/findNonTierLayersIds';

class TierInStylePositionDesignator {

    constructor(map, tiers) {
        this._map = map;
        this._tiers = tiers;

        const allLayers = this._map.getStyle().layers;
        this._firstLayerIdFromTiers = getFirstLayerIdFromTiers(this._tiers);
        const lastLayerIdFromTiers = getLastLayerIdFromTiers(this._tiers);
        this._nonTierLayersIds = findNonTierLayersIds(allLayers, lastLayerIdFromTiers);
    }

    findBeforeLayerIdFor = (tier) => {
        const tierIndex = this._tiers.indexOf(tier);
        return this._firstLayerIdFromTiers.slice(tierIndex + 1).concat(this._nonTierLayersIds)
            .find(layerId => this._map.getLayer(layerId));
    }

}

export default (map, tiers) => {
    return new TierInStylePositionDesignator(map, tiers);
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/tierInStylePositionDesignator.js